<template>
    <Head>
        <title>Биржи</title>
    </Head>

    <authenticated-layout>

        <template #header>
            <organization-navigation :organization-id="organization.id"/>
        </template>

        <div class="flex flex-col bg-white p-6">

            <form action="#" method="post"
                  class="grid grid-cols-5 items-end justify-items-start gap-4 pb-4"
                  @submit.prevent="save"
                  @change="waitSend = false"
            >
                <v-toggle v-model="organization.allowCrosschainSwaps" label="Доступа к обменам" class="mb-2"/>
                <v-toggle v-model="organization.allowCrosschainTransfers" label="Доступа к трансферам" class="mb-2"/>
                <v-select label="Группа бирж" v-model="organization.exchangeGroup" :error="errors.exchangeGroup">
                    <option :value="null">Отключено</option>
                    <option v-for="group in Object.keys(result)" :value="group">{{ group }}</option>
                </v-select>
                <v-button color="green" :disabled="waitSend">Сохранить</v-button>
            </form>

            <div class="grid grid-cols-5 p-2 gap-2 items-center font-bold">
                <span class="col-span-2">id</span>
                <span>Группа</span>
                <span>Для</span>
                <span>Описание</span>
            </div>

            <div v-for="row in result[organization.exchangeGroup]" class="grid grid-cols-5 border-t p-2 gap-2 items-center">
                <span class="col-span-2 text-sm">{{ row.id }}</span>
                <span>{{ row.group }}</span>
                <span>{{ row.useFor }}</span>
                <span>{{ row.alias }}</span>

            </div>

        </div>


    </authenticated-layout>

</template>

<script>
import {Head, Link} from '@inertiajs/inertia-vue3';
import AuthenticatedLayout from '@/Layouts/Authenticated';
import OrganizationNavigation from "@/Components/Navigation/Organization";
import VButton from "@/Components/Button";
import VSelect from "@/Components/Select";
import VToggle from '@/Components/Toggle';

export default {
    components: {
        OrganizationNavigation,
        Head, Link,
        AuthenticatedLayout,
        VButton,
        VSelect,
        VToggle,
    },
    props: {
        organization: Object,
        result: Object,
        notifications: Array,
        errors: Object,
    },
    data() {
        return {
            waitSend: true,
        }
    },
    methods: {
        save() {
            const {exchangeGroup, organization} = this;
            this.waitSend = true;
            axios.post(this.route('organization.update', organization.id), {exchangeGroup})
                .then((res) => {
                    const {success, result, notifications} = res.data;
                    this.notifications.push(...notifications);
                    organization.exchangeGroup = exchangeGroup;
                    this.waitSend = false;
                });
        }
    },
}
</script>
